

export default class FileUtil {

    /**
     * 
     * @param {File} file 
     * @returns {Promise<string>}
     */
    static FileToDataURL(file) {
        return new Promise(next => {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                // @ts-ignore
                next(fileReader.result);
            }
            if (file) {
                fileReader.readAsDataURL(file)
            }
        })
    }

    /**
         * 
         * @param {File} file 
         * @returns {Promise<ArrayBuffer>}
         */
    static FileToArrayBuffer(file) {
        return new Promise(next => {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                // @ts-ignore
                next(fileReader.result);
            }
            if (file) {
                fileReader.readAsArrayBuffer(file)
            }

        })
    }



}